module.exports = __webpack_public_path__ + "img/c-max.266699fb.png";